<template>
    <v-card outlined tile class="tw-w-full !tw-p-0">
        <v-row
            class="tw-flex tw-flex-row tw-items-center tw-justify-between !tw-p-0"
        >
            <v-col cols="3" no-gutters>
                <v-icon large class="tw-ml-3" color="grey lighten-1"
                    >mdi-account-circle-outline</v-icon
                >
            </v-col>

            <v-col cols="7" no-gutters class="tw-p-0">
                <div class="tw-flex tw-flex-col tw-justify-between">
                    <div class="tw-flex tw-flex-col tw-text-left">
                        <div class="tw-text-sm tw-font-bold">
                            {{ name }}
                            <span
                                v-if="isOwner"
                                class="tw-font-normal tw-text-textSecondary"
                            >
                                (Owner)
                            </span>
                        </div>
                    </div>
                    <p
                        class="!tw-m-0 !tw-p-0 tw-text-sm tw-font-normal tw-text-success"
                    >
                        {{ numberClassesUsed }}/{{ numberClassesShared }}
                    </p>
                </div>
            </v-col>

            <v-col cols="2" no-gutters class="tw-m-0 tw-cursor-pointer tw-p-0">
                <v-icon
                    v-if="canEdit"
                    :color="webAppFontColor"
                    @click="editSharedPackage"
                    >mdi-pencil-outline</v-icon
                >
            </v-col>
        </v-row>

        <BaseDialog
            v-model="editDialog.isOpen.value"
            :title="editSharedPackageTitle"
            headerClass="tw-text-webAppFontColor tw-pt-8"
            :showCloseButton="true"
            :onClose="editDialog.closeDialog"
        >
            <EditPackageShareCard
                :packageItem="packageItem"
                :user="{ email: email, fullName: name, id: userId }"
                :sharedPackage="sharedPackage"
                @onSuccessEdit="onSuccessEdit"
            />
        </BaseDialog>
    </v-card>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useStudioStore } from '../bookclass/stores/studioStore'
import BaseDialog from '@/components/base/dialog/BaseDialog.vue'
import { useDialog } from '@/components/base/dialog/composable/useDialog'
import EditPackageShareCard from './EditPackageShareCard.vue'
import { useI18n } from 'vue-i18n-composable'

const editDialog = useDialog()
const emit = defineEmits<{
    (e: 'onSuccessEdit'): void
}>()
const {
    name,
    numberClassesUsed,
    numberClassesShared,
    packageItem,
    sharedPackage,
} = defineProps({
    packageItem: {
        type: Object,
        required: true,
    },
    sharedPackage: {
        type: Object,
        required: true,
    },
    userId: String,
    email: String,
    username: String,
    name: String,
    numberClassesUsed: Number,
    numberClassesShared: Number,
})

const { t: $t } = useI18n()
const editSharedPackageTitle = computed(() => {
    return $t('message.editSharedPackage').toString()
})
const studioStore = useStudioStore()

const isOwner = computed(() => {
    return packageItem.userId === sharedPackage.userId
})

const canEdit = computed(() => {
    return !isOwner.value
})

function editSharedPackage() {
    editDialog.openDialog()
}

function onSuccessEdit() {
    editDialog.closeDialog()
    emit('onSuccessEdit')
}

const webAppFontColor = computed(() => {
    return studioStore.studio.webAppFontColor
})
</script>
